// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1B-Am","ranges":"BmiRanges_ranges__3ifDd"};